import React from "react"

type ToggleSearchProps = {
  onClick: () => void
  entityName: string
  open: boolean
}

export const ToggleSearch = ({
  onClick,
  entityName,
  open,
}: ToggleSearchProps) => {
  return (
    <button
      data-test="toggle-search__button"
      onClick={onClick}
      aria-controls={`${entityName}-search`}
      aria-label="Show search box"
      className={`flex -m-px dropdown-button dropdown-button--toggle ${open && "dropdown-button--toggle-active"}`}
      id={`${entityName}-search-toggle`}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4351 12.0629H12.7124L12.4563 11.8159C13.3528 10.773 13.8925 9.4191 13.8925 7.94626C13.8925 4.66209 11.2304 2 7.94626 2C4.66209 2 2 4.66209 2 7.94626C2 11.2304 4.66209 13.8925 7.94626 13.8925C9.4191 13.8925 10.773 13.3528 11.8159 12.4563L12.0629 12.7124V13.4351L16.6369 18L18 16.6369L13.4351 12.0629ZM7.94626 12.0629C5.66838 12.0629 3.82962 10.2241 3.82962 7.94626C3.82962 5.66838 5.66838 3.82962 7.94626 3.82962C10.2241 3.82962 12.0629 5.66838 12.0629 7.94626C12.0629 10.2241 10.2241 12.0629 7.94626 12.0629Z"
          fill="#171A1B"
        />
      </svg>
      <span className="sr-only">Show search box</span>
    </button>
  )
}
